// extracted by mini-css-extract-plugin
export var actionText = "_py-4";
export var container = "_py-0";
export var leftSection = "_py-1";
export var rightSection = "_py-2";
export var settingsButton = "_py-6";
export var settingsIcon = "_py-7";
export var shortcut = "_py-5";
export var shortcutGroup = "_py-3";